import { render, staticRenderFns } from "./MostLikelyMorphologicCodesGrid.vue?vue&type=template&id=663b3bd0&scoped=true&"
import script from "./MostLikelyMorphologicCodesGrid.ts?vue&type=script&lang=ts&"
export * from "./MostLikelyMorphologicCodesGrid.ts?vue&type=script&lang=ts&"
import style0 from "./MostLikelyMorphologicCodesGrid.scss?vue&type=style&index=0&id=663b3bd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b3bd0",
  null
  
)

export default component.exports